export const frLocale = {
  direction: "ltr",
  format: "yyyy/mm/dd",
  separator: " → ",
  applyLabel: "Appliquer",
  cancelLabel: "Annuler",
  weekLabel: "S",
  customRangeLabel: "Personnalisé",
  daysOfWeek: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
  monthNames: [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre"
  ],
  firstDay: 1
};

export const frRanges = {
  "Aujourd’hui": [new Date(), new Date()],

  "Hier": [
    new Date(Date.now() - 86400000),
    new Date(Date.now() - 86400000)
  ],

  "Ce mois-ci": [
    new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    new Date()
  ],

  "Cette année": [
    new Date(new Date().getFullYear(), 0, 1),
    new Date()
  ],

  "Le mois dernier": [
    new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
    new Date(new Date().getFullYear(), new Date().getMonth(), 0)
  ]
};